<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <number-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import NumberFieldMixin from 'vue-forms/mixins/NumberFieldMixin';

export default {
  mixins: [ FormFieldMixin, NumberFieldMixin ],
};
</script>
